import type { IncomingMaterialsTranslation } from './types'

/**
 * Urdu translations for Incoming Materials domain
 */
export const incoming_materialsTranslationUr: IncomingMaterialsTranslation = {
  // Page/Section level
  title: 'آنے والا مال',
  subtitle: 'خریداری کے آرڈرز، سپلائرز، اور سامان کی وصولی کا انتظام کریں',
  description: 'سسٹم میں آنے والے مال کا انتظام کریں',

  // Purchase Order
  purchaseOrder: 'خریداری کا آرڈر',
  poNumber: 'پی او نمبر',
  poDate: 'پی او تاریخ',
  poDetails: 'خریداری آرڈر کی تفصیلات',
  poLinesTitle: 'آرڈر لائنز',
  poLinesHint: 'اس خریداری آرڈر میں مال شامل کریں',

  // PO Status
  poStatus: {
    draft: 'ڈرافٹ',
    issued: 'جاری شدہ',
    closed: 'بند',
    cancelled: 'منسوخ',
    pending: 'زیر التواء',
    completed: 'مکمل',
  },
  factory: 'فیکٹری',
  materialGroup: 'میٹیریل گروپ',

  // Receipt Status
  receiptStatus: {
    pending: 'وصولی زیر التواء',
    partial: 'جزوی وصولی',
    complete: 'مکمل',
  },

  // Line Status
  status: {
    pending: 'زیر التواء',
    partial: 'جزوی',
    accepted: 'منظور',
    rejected: 'مسترد',
    disputed: 'متنازعہ',
  },

  // Create/Actions
  createTitle: 'خریداری آرڈر بنائیں',
  createHint: 'آنے والے مال کے لیے نیا خریداری آرڈر بنائیں',
  createPurchaseOrder: 'خریداری آرڈر بنائیں',
  createPOHint: 'آنے والے مال کی ٹریکنگ کے لیے نیا خریداری آرڈر شامل کریں',
  createSupplier: 'سپلائر بنائیں',
  createMaterial: 'مال بنائیں',
  createMaterialHint: 'کیٹلاگ میں نیا مال شامل کریں',
  createFirstPO: 'اپنا پہلا خریداری آرڈر بنائیں',
  receiveGoods: 'سامان وصول کریں',
  receiveHint: 'خریداری آرڈر کے خلاف سامان کی وصولی ریکارڈ کریں',
  confirmReceipt: 'وصولی کی تصدیق کریں',
  sendToAds: 'ADS کو بھیجیں',
  sendingToAds: 'ADS کو بھیجا جا رہا ہے...',
  sendToAdsSuccess: 'خریداری آرڈر ADS کو بھیج دیا گیا',
  sendToAdsFailure: 'خریداری آرڈر ADS کو نہیں بھیجا جا سکا',

  // Lines
  linesTitle: 'آرڈر لائنز',
  linesHint: 'وصول ہونے والا مال',
  addLine: 'لائن شامل کریں',
  removeLine: 'لائن ہٹائیں',
  receiveLines: 'لائنز وصول کریں',
  receiveLinesHint: 'ہر لائن کے لیے وصول شدہ مقدار درج کریں',
  noPoLines: 'اس خریداری آرڈر میں کوئی لائنز نہیں ہیں',

  // Supplier
  supplier: 'سپلائر',
  supplierName: 'سپلائر کا نام',
  supplierCode: 'سپلائر کوڈ',
  taxId: 'ٹیکس آئی ڈی / ویٹ نمبر',
  noSupplier: 'کوئی سپلائر منتخب نہیں',

  // Material
  materialName: 'مال کا نام',
  materialCode: 'مال کوڈ',
  materialDescription: 'مال کی تفصیل',

  // Fields
  fields: {
    supplier: 'سپلائر',
    purchaseOrder: 'خریداری آرڈر',
    purchaseOrderLine: 'پی او لائن',
    material: 'مال',
    quantity: 'مقدار',
    status: 'حیثیت',
    receivedAt: 'وصولی کا وقت',
    driverName: 'ڈرائیور کا نام',
    driverPhone: 'ڈرائیور کا فون',
    vehiclePlate: 'گاڑی کی پلیٹ',
    supplierDeliveryNoteNo: 'ڈیلیوری نوٹ نمبر',
    notes: 'نوٹس',
  },

  // Placeholders
  placeholders: {
    selectSupplier: 'سپلائر منتخب کریں',
    supplierName: 'سپلائر کا نام درج کریں',
    selectPurchaseOrder: 'خریداری آرڈر منتخب کریں',
    selectPurchaseOrderLine: 'پی او لائن منتخب کریں',
    selectMaterial: 'مال منتخب کریں',
    materialName: 'مال کا نام درج کریں',
    materialDescription: 'مال کی تفصیل درج کریں',
    deliveryNote: 'ڈیلیوری نوٹ نمبر درج کریں',
    driverName: 'ڈرائیور کا نام درج کریں',
    driverPhone: 'ڈرائیور کا فون درج کریں',
    vehiclePlate: 'گاڑی کی پلیٹ درج کریں',
    notes: 'نوٹس درج کریں',
  },

  // Validation
  validation: {
    supplierNameRequired: 'سپلائر کا نام ضروری ہے',
    supplierCodeRequired: 'سپلائر کوڈ ضروری ہے',
  },

  // Table
  table: {
    materials: 'مال',
    receiptStatus: 'وصولی کی حیثیت',
    moreItems: 'مزید اشیاء',
    showing: '{{start}}-{{end}} از {{total}} دکھا رہے ہیں',
    perPage: 'فی صفحہ',
  },

  filters: {
    title: 'فلٹرز',
    all: 'تمام',
    apply: 'لاگو کریں',
    clearAll: 'سب صاف کریں',
    status: 'حیثیت',
    supplier: 'سپلائر',
    material: 'مواد',
    supplierSearchPlaceholder: 'سپلائر تلاش کریں...',
    materialSearchPlaceholder: 'مواد تلاش کریں...',
    loading: 'لوڈ ہو رہا ہے...',
    noSuppliers: 'کوئی سپلائر نہیں ملا',
    noMaterials: 'کوئی مواد نہیں ملا',
  },

  // Other
  expectedDeliveryDate: 'متوقع ڈیلیوری تاریخ',
  uom: 'پیمائش کی اکائی',
  defaultUom: 'عدد',
  overallProgress: 'مجموعی پیشرفت',
  received: 'موصول',
  complete: 'مکمل',
  receiptsHistory: 'وصولی کی تاریخ',
  notesPlaceholder: 'اس وصولی کے بارے میں نوٹس شامل کریں...',
  searchPOs: 'خریداری آرڈرز تلاش کریں...',
  noPurchaseOrders: 'کوئی خریداری آرڈر نہیں ملا',
  noMatchingPOs: 'کوئی مماثل خریداری آرڈر نہیں',
  totalPOs: 'کل خریداری آرڈرز',
  filteredPOs: 'فلٹر شدہ خریداری آرڈرز',
  showingPOs: 'دکھائے جانے والے خریداری آرڈرز',
  items: 'اشیاء',
  receipts: 'رسیدیں',
  receivedQty: 'وصول شدہ مقدار: {{qty}} {{uom}}',
  orderedVsReceived: 'آرڈر شدہ بمقابلہ وصول شدہ',
  selectedSupplier: 'منتخب سپلائر',

  // Actions (legacy)
  actions: {
    create: 'بنائیں',
    edit: 'ترمیم کریں',
    delete: 'حذف کریں',
    view: 'دیکھیں',
    save: 'محفوظ کریں',
    cancel: 'منسوخ کریں',
  },

  // Form (legacy)
  form: {
    name: 'نام',
    description: 'تفصیل',
    status: 'حیثیت',
  },

  // Messages
  messages: {
    created: 'آنے والا مال کامیابی سے بنایا گیا',
    updated: 'آنے والا مال کامیابی سے اپ ڈیٹ ہوا',
    deleted: 'آنے والا مال کامیابی سے حذف ہوا',
    error: 'ایک خرابی واقع ہوئی',
  },

  // Inbound Shipments
  kioskInbound: {
    title: 'کیا آپ ہمیں ڈیلیوری دے رہے ہیں؟',
    subtitle: 'اگر گیٹ آپ کا QR یا نمبر پلیٹ نہ پڑھ سکا تو یہاں رجسٹر کریں۔',
    plateLabel: 'آپ کا نمبر پلیٹ',
    plateDigitsPlaceholder: '1234',
    plateLettersPlaceholder: 'ABC',
    poNumberLabel: 'پرچیز آرڈر نمبر',
    poNumberPlaceholder: 'مثلاً 4500000219',
    lineNumberLabel: 'لائن آئٹم نمبر',
    lineNumberPlaceholder: 'مثلاً 0010',
    scanHint: 'کیا آپ کے کاغذات پر QR ہے؟ اسے اسکین کر کے یہ خانے بھریں۔',
    scanNotRecognised: 'یہ کوڈ پڑھا نہیں جا سکا۔ دوبارہ کوشش کریں یا نیچے نمبر ٹائپ کریں۔',
    findLoads: 'جاری رکھیں',
    remainingOf: '{{ordered}} {{uom}} میں سے {{remaining}} باقی',
    register: 'میری آمد رجسٹر کریں',
    registering: 'رجسٹر ہو رہا ہے…',
    startOver: 'دوبارہ شروع کریں',
    successTitle: 'آپ رجسٹر ہو گئے',
    successHint: 'اپنی پرچی لیں اور گیٹ پر جائیں۔ آپ کی پلیٹ پر گیٹ کھل جائے گا۔',
    printAgain: 'پرچی دوبارہ پرنٹ کریں',
    poNotFound: 'اس نمبر کا کوئی پرچیز آرڈر نہیں ملا۔',
    lineNotOnPo: 'لائن {{line}} اس پرچیز آرڈر میں نہیں ہے۔',
    lineFullyReceived: 'لائن {{line}} پہلے ہی مکمل ڈیلیور ہو چکی ہے۔',
  },

  inboundShipments: {
    title: 'آنے والی شپمنٹس',
    subtitle: 'آنے والی شپمنٹس اور وے برج آپریشنز کا انتظام کریں',
    searchPlaceholder: 'شپمنٹ #، پلیٹ، یا پی او نمبر سے تلاش کریں...',
    noShipments: 'کوئی آنے والی شپمنٹ نہیں ملی',
    noMatchingShipments: 'آپ کی تلاش یا فلٹر سے کوئی شپمنٹ نہیں ملی',
    totalShipments: 'کل شپمنٹس',
    showingShipments: 'دکھائی جانے والی شپمنٹس',
    shipmentNumber: 'شپمنٹ نمبر',
    vehiclePlate: 'گاڑی کی پلیٹ',
    driver: 'ڈرائیور',
    arrivedAt: 'آمد کا وقت',
    grossWeight: 'مجموعی وزن (کلوگرام)',
    tareWeight: 'خالی وزن (کلوگرام)',
    netWeight: 'خالص وزن (کلوگرام)',
    firstWeightAt: 'پہلا وزن',
    secondWeightAt: 'دوسرا وزن',
    grnNumber: 'جی آر این نمبر',
    sapMaterialDocument: 'SAP میٹیریل دستاویز',
    sapSyncStatus: 'SAP مطابقت',
    purchaseOrder: 'خریداری آرڈر',
    supplier: 'سپلائر',
    gate: 'گیٹ',
    statusFilter: {
      all: 'سب',
      arrived: 'پہنچ گئی',
      first_weight_done: 'پہلا وزن مکمل',
      unloaded: 'اتاری گئی',
      second_weight_done: 'دوسرا وزن مکمل',
      grn_posted: 'جی آر این پوسٹ',
      grn_skipped: 'جی آر این چھوڑ دیا',
    },
    sapSyncStatusLabel: {
      pending: 'زیر التواء',
      first_weight_synced: 'پہلا وزن مطابقت شدہ',
      second_weight_synced: 'دوسرا وزن مطابقت شدہ',
      grn_synced: 'جی آر این مطابقت شدہ',
      failed: 'ناکام',
    },
    filters: {
      title: 'فلٹرز',
      all: 'تمام',
      apply: 'لاگو کریں',
      clearAll: 'سب صاف کریں',
      status: 'حیثیت',
      supplier: 'سپلائر',
      material: 'مواد',
      supplierSearchPlaceholder: 'سپلائر تلاش کریں...',
      materialSearchPlaceholder: 'مواد تلاش کریں...',
      loading: 'لوڈ ہو رہا ہے...',
      noSuppliers: 'کوئی سپلائر نہیں ملا',
      noMaterials: 'کوئی مواد نہیں ملا',
      sapSyncStatus: 'SAP مطابقت',
      grnStatus: 'جی آر این',
      weightStatus: 'وزن',
    },
    grnFilter: {
      all: 'تمام جی آر این',
      posted: 'جی آر این پوسٹ',
      not_posted: 'جی آر این نہیں',
    },
    weightFilter: {
      all: 'تمام وزن',
      gross_recorded: 'مجموعی ریکارڈ',
      net_recorded: 'خالص ریکارڈ',
      missing_weight: 'وزن غائب',
    },
    columns: {
      shipmentNumber: 'شپمنٹ #',
      vehiclePlate: 'گاڑی کی پلیٹ',
      purchaseOrder: 'پی او نمبر',
      material: 'مواد',
      status: 'حیثیت',
      grossWeight: 'مجموعی (کلوگرام)',
      netWeight: 'خالص (کلوگرام)',
      sapSyncStatus: 'SAP مطابقت',
      grnNumber: 'جی آر این #',
      arrivedAt: 'آمد',
    },
    detail: {
      title: 'شپمنٹ کی تفصیلات',
      overview: 'جائزہ',
      timeline: 'ٹائم لائن',
      shipmentInfo: 'شپمنٹ کی معلومات',
      weightInfo: 'وزن کی معلومات',
      syncInfo: 'SAP مطابقت',
      driverName: 'ڈرائیور کا نام',
      edit: 'ترمیم',
      save: 'محفوظ کریں',
      cancel: 'منسوخ کریں',
      departedAt: 'روانگی کا وقت',
      factory: 'فیکٹری',
      storageLocation: 'اسٹوریج لوکیشن',
      poNumber: 'پی او نمبر',
      sapPoNumber: 'SAP پی او نمبر',
      sapItemNumber: 'SAP آئٹم',
      material: 'مواد',
      orderedQuantity: 'آرڈر مقدار',
      ticketNumber: 'ٹکٹ نمبر',
      firstWeightSyncedAt: 'پہلا وزن مطابقت وقت',
      secondWeightSyncedAt: 'دوسرا وزن مطابقت وقت',
      grnSyncedAt: 'جی آر این مطابقت وقت',
      error: 'خرابی',
      success: 'کامیاب',
      failed: 'ناکام',
      timelineEvents: 'واقعات',
      noTimeline: 'ابھی کوئی ٹائم لائن واقعہ نہیں',
      timelineError: 'ٹائم لائن لوڈ نہیں ہوئی',
      refreshTimeline: 'ٹائم لائن ریفریش کریں',
      timelineStep: 'مرحلہ',
      timelineStatus: 'حیثیت',
      weightKg: 'وزن',
      netWeightKg: 'خالص وزن',
      timelineActions: {
        CREATED: 'بنایا گیا',
        WEIGHBRIDGE_TRIGGERED: 'وے برج فلو',
        GATE_OPENED: 'گیٹ کھولا گیا',
        INBOUND_FIRST_WEIGHT: 'پہلا وزن',
        INBOUND_SECOND_WEIGHT: 'دوسرا وزن',
        INBOUND_GRN: 'جی آر این',
      },
      timelineEmpty: 'ابھی کوئی ٹائم لائن ایونٹ نہیں',
      timelineLoadError: 'ٹائم لائن لوڈ نہیں ہو سکی',
      timelineSuccess: 'کامیاب',
      timelineFailed: 'ناکام',
      timelineRefresh: 'ریفریش',
    },
  },
}
